<template>
  <div class="comic-homepage">
    <!-- 背景装饰元素 -->
    <div class="bg-decoration bg-circle-1"></div>
    <div class="bg-decoration bg-circle-2"></div>
    <div class="bg-decoration bg-circle-3"></div>
    <div class="bg-decoration bg-circle-4"></div>
    
    <!-- 呼吸灯效果 -->
    <div class="breathing-light"></div>
    
    <!-- 鼠标追踪光效 -->
    <div class="mouse-glow" ref="mouseGlow"></div>
    
    <!-- 粒子特效 -->
    <div class="particles-container">
      <div class="particle particle-1"></div>
      <div class="particle particle-2"></div>
      <div class="particle particle-3"></div>
      <div class="particle particle-4"></div>
      <div class="particle particle-5"></div>
      <div class="particle particle-6"></div>
      <div class="particle particle-7"></div>
      <div class="particle particle-8"></div>
      <div class="particle particle-9"></div>
      <div class="particle particle-10"></div>
      <div class="particle particle-11"></div>
      <div class="particle particle-12"></div>
      <div class="particle particle-star-1"></div>
      <div class="particle particle-star-2"></div>
      <div class="particle particle-star-3"></div>
      <div class="particle particle-star-4"></div>
      <div class="particle particle-star-5"></div>
    </div>
    
    <!-- 浮动图标装饰 -->
    <div class="floating-icons">
      <div class="floating-icon icon-book">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"></path><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"></path></svg>
      </div>
      <div class="floating-icon icon-star">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"></polygon></svg>
      </div>
      <div class="floating-icon icon-heart">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>
      </div>
    </div>

    <section class="cinema-dashboard">
      <div class="container">
        <div class="dashboard-grid">
          <article class="spotlight-panel" v-if="featuredComic" @click="goToComicDetail(featuredComic.id)">
            <div class="spotlight-cover">
              <img :src="getImageUrl(featuredComic.cover)" :alt="featuredComic.title">
            </div>
            <div class="spotlight-copy">
              <p class="eyebrow">今日主推</p>
              <h1>{{ featuredComic.title }}</h1>
              <p class="spotlight-desc">{{ featuredComic.description || '精选漫画正在等你继续阅读。' }}</p>
              <div class="spotlight-meta">
                <span>{{ featuredComic.author || '未知作者' }}</span>
                <span>{{ featuredComic.is_paid ? '含VIP章节' : '免费阅读' }}</span>
              </div>
              <button class="read-now">立即阅读</button>
            </div>
          </article>

          <aside class="ranking-panel">
            <div class="panel-title">
              <span>阅读榜</span>
              <button @click="goToCategory">书库</button>
            </div>
            <div
              class="rank-row"
              v-for="(item, index) in rankingComics"
              :key="item.id"
              @click="goToComicDetail(item.id)"
            >
              <strong>{{ String(index + 1).padStart(2, '0') }}</strong>
              <img :src="getImageUrl(item.cover)" :alt="item.title">
              <div>
                <h3>{{ item.title }}</h3>
                <p>{{ item.author || '未知作者' }}</p>
              </div>
            </div>
          </aside>
        </div>

        <div class="quick-lanes">
          <button @click="goToCategory">全部漫画</button>
          <button @click="goToCategory">免费专区</button>
          <button @click="goToCategory">会员精选</button>
          <button @click="goToCategory">最新更新</button>
        </div>
      </div>
    </section>

    <section class="library-floor">
      <div class="container">
        <div class="shelf-layout">
          <div class="shelf-main">
            <div class="section-header">
              <h2>新书上架</h2>
              <a href="javascript:void(0)" class="more" @click="goToCategory">查看全部</a>
            </div>
            <div class="latest-grid shelf-grid">
              <div class="latest-card" v-for="item in latestComics" :key="item.id" @click="goToComicDetail(item.id)">
                <div class="comic-cover">
                  <img :src="getImageUrl(item.cover)" :alt="item.title">
                  <span class="update-badge" v-if="item.is_paid">付费</span>
                  <span class="update-badge free" v-else>免费</span>
                </div>
                <h4 class="comic-title">{{ item.title }}</h4>
                <p class="comic-author">作者：{{ item.author }}</p>
              </div>
            </div>
          </div>

          <aside class="editor-picks">
            <h2>编辑精选</h2>
            <div class="pick-card" v-for="item in completedComics.slice(0, 4)" :key="item.id" @click="goToComicDetail(item.id)">
              <img :src="getImageUrl(item.cover)" :alt="item.title">
              <div>
                <h3>{{ item.title }}</h3>
                <p>{{ item.description || item.author || '精选作品' }}</p>
              </div>
            </div>
          </aside>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import api from '../api/index'
import request from '../api/request'

export default {
  name: 'ComicHomepage',
  data() {
    return {
      baseImgUrl: request.baseUrl,
      banners: [], // 轮播图数据
      currentBannerIndex: 0, // 当前轮播图索引
      bannerTimer: null, // 轮播图定时器
      hotComics: [], // 热门漫画数据
      allComics: [], // 所有漫画数据（用于随机选择）
      latestComics: [], // 最新更新漫画数据
      completedComics: [], // 完结佳作漫画数据
      currentCategory: '热血',
      mouseX: 0, // 鼠标X坐标
      mouseY: 0, // 鼠标Y坐标
      isMouseMoving: false, // 鼠标是否移动中
      mouseStopTimer: null, // 鼠标停止计时器
    }
  },
  created() {
    // 设置页面标题
    document.title = '道晗漫画平台 - 精彩漫画尽在此处'
    // 获取轮播图数据
    this.fetchBannerList()
    // 获取漫画列表数据
    this.fetchComicList()
  },
  computed: {
    featuredComic() {
      return this.hotComics[0] || this.latestComics[0] || this.completedComics[0] || null
    },
    rankingComics() {
      return [...this.hotComics, ...this.latestComics].filter(Boolean).slice(0, 6)
    }
  },
  mounted() {
    // 轮播在fetchBannerList成功后自动启动
    // 添加鼠标移动监听
    window.addEventListener('mousemove', this.handleMouseMove)
    // 添加滚动监听
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeUnmount() {
    // 组件销毁前清除定时器和事件监听
    this.stopBannerAutoPlay()
    window.removeEventListener('mousemove', this.handleMouseMove)
    window.removeEventListener('scroll', this.handleScroll)
    if (this.mouseStopTimer) {
      clearTimeout(this.mouseStopTimer)
    }
  },
  methods: {
    getImageUrl(url) {
      if (!url) return ''
      if (/^https?:\/\//i.test(url)) return url
      if (url.startsWith('//')) return window.location.protocol + url
      return this.baseImgUrl + (url.startsWith('/') ? url : `/${url}`)
    },

    // 处理页面滚动
    handleScroll() {
      // 获取所有区域元素
      const sections = document.querySelectorAll('section')
      
      // 为每个区域添加滚动动画
      sections.forEach(section => {
        const rect = section.getBoundingClientRect()
        const windowHeight = window.innerHeight
        
        // 计算元素在视口中的位置
        const vertInView = (rect.top <= windowHeight) && ((rect.top + rect.height) >= 0)
        
        if (vertInView) {
          // 计算元素在视口中的百分比
          const distFromTop = rect.top
          const scrollPercent = 1 - (distFromTop / windowHeight)
          
          // 根据滚动百分比设置动画效果
          if (scrollPercent >= 0 && scrollPercent <= 1) {
            // 透明度和缩放效果
            const scale = 0.9 + scrollPercent * 0.1
            const opacity = 0.7 + scrollPercent * 0.3
            
            section.style.opacity = opacity
            section.style.transform = `scale(${scale})`
            section.style.filter = `blur(${(1 - scrollPercent) * 3}px)`
          }
        }
      })
    },
    
    // 处理鼠标移动
    handleMouseMove(event) {
      this.mouseX = event.clientX
      this.mouseY = event.clientY
      
      // 处理鼠标光效
      if (this.$refs.mouseGlow) {
        this.$refs.mouseGlow.style.left = `${this.mouseX}px`
        this.$refs.mouseGlow.style.top = `${this.mouseY}px`
        
        // 添加移动中的类
        if (!this.isMouseMoving) {
          this.isMouseMoving = true
          this.$refs.mouseGlow.classList.add('active')
        }
        
        // 重置鼠标停止计时器
        if (this.mouseStopTimer) {
          clearTimeout(this.mouseStopTimer)
        }
        
        // 设置新的计时器
        this.mouseStopTimer = setTimeout(() => {
          this.isMouseMoving = false
          this.$refs.mouseGlow.classList.remove('active')
        }, 2000)
      }
      
      // 获取所有卡片元素
      const cards = document.querySelectorAll('.comic-item, .latest-card, .completed-card')
      
      // 为每个卡片添加3D倾斜效果
      cards.forEach(card => {
        const rect = card.getBoundingClientRect()
        const cardX = rect.left + rect.width / 2
        const cardY = rect.top + rect.height / 2
        
        // 计算鼠标与卡片中心的距离
        const distX = this.mouseX - cardX
        const distY = this.mouseY - cardY
        
        // 距离范围内才应用效果
        const maxDist = 300
        const dist = Math.sqrt(distX * distX + distY * distY)
        
        if (dist < maxDist) {
          // 计算旋转角度，距离越近效果越明显
          const power = 1 - dist / maxDist
          const rotateX = distY * power * 5 / 30 // 最大5度
          const rotateY = -distX * power * 5 / 30 // 最大5度
          
          // 应用变换
          card.style.transform = `perspective(1000px) rotateX(${rotateX}deg) rotateY(${rotateY}deg) scale(1.03)`
        } else {
          // 重置变换
          card.style.transform = ''
        }
      })
    },
    
    // 获取轮播图数据
    async fetchBannerList() {
      try {
        const res = await api.getBannerList({ type: 'index' })
        this.banners = res.data || []
        // 数据加载完成后再启动轮播
        if (this.banners.length > 0) {
          this.$nextTick(() => {
            this.startBannerAutoPlay()
          })
        }
      } catch (error) {
        console.error('获取轮播图失败:', error)
      }
    },
    
    // 获取漫画列表数据
    async fetchComicList() {
      try {
        const res = await api.getComicList()
        if (res.data && res.data.list && res.data.list.length > 0) {
          this.allComics = res.data.list
          // 随机选择漫画作为热门推荐
          this.randomizeHotComics()
          // 随机选择漫画作为最新更新
          this.randomizeLatestComics()
          // 随机选择漫画作为完结佳作
          this.randomizeCompletedComics()
        }
      } catch (error) {
        console.error('获取漫画列表失败:', error)
      }
    },
    
    // 随机选择漫画作为热门推荐
    randomizeHotComics() {
      if (this.allComics.length === 0) return
      
      // 青少年模式的内容过滤已由服务端完成，这里直接使用返回结果
      const comics = [...this.allComics]
      
      // 打乱数组顺序
      this.shuffleArray(comics)
      
      // 选取前4个（或更少）作为热门推荐
      this.hotComics = comics.slice(0, 4)
    },
    
    // 随机选择漫画作为最新更新
    randomizeLatestComics() {
      if (this.allComics.length === 0) return
      
      const comics = [...this.allComics]
      
      // 打乱数组顺序
      this.shuffleArray(comics)
      
      // 选取前10个（或更少）作为最新更新，适应5x2的网格布局
      this.latestComics = comics.slice(0, 10).map(item => {
        // 确保每个项目都有必要的属性
        return {
          ...item,
          is_paid: item.is_paid || 0
        }
      })
      
      console.log('最新更新数据:', this.latestComics)
    },
    
    // 随机选择漫画作为完结佳作
    randomizeCompletedComics() {
      if (this.allComics.length === 0) return
      
      const comics = [...this.allComics]
      
      // 打乱数组顺序
      this.shuffleArray(comics)
      
      // 选取前10个（或更少）作为完结佳作，确保有足够数据填充5x2网格
      this.completedComics = comics.slice(0, 10).map(item => {
        // 确保每个项目都有必要的属性
        return {
          ...item,
          description: item.description || '暂无简介',
          is_paid: item.is_paid || 0
        }
      })
      
      console.log('完结佳作数据:', this.completedComics)
    },
    
    // 数组随机打乱（Fisher-Yates 洗牌算法）
    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [array[i], array[j]] = [array[j], array[i]]
      }
      return array
    },
    
    // 设置当前轮播图
    setActiveBanner(index) {
      this.currentBannerIndex = index
      // 重置定时器
      this.stopBannerAutoPlay()
      this.startBannerAutoPlay()
    },
    
    // 上一张轮播图
    prevBanner() {
      if (!this.banners || this.banners.length <= 1) return
      this.currentBannerIndex = (this.currentBannerIndex - 1 + this.banners.length) % this.banners.length
      // 重置定时器
      this.stopBannerAutoPlay()
      this.startBannerAutoPlay()
    },
    
    // 下一张轮播图
    nextBanner() {
      if (!this.banners || this.banners.length <= 1) return
      this.currentBannerIndex = (this.currentBannerIndex + 1) % this.banners.length
      // 重置定时器
      this.stopBannerAutoPlay()
      this.startBannerAutoPlay()
    },
    
    // 开始轮播图自动播放
    startBannerAutoPlay() {
      if (!this.banners || this.banners.length <= 1) return
      // 确保清除旧的定时器
      this.stopBannerAutoPlay()
      this.bannerTimer = setInterval(() => {
        this.nextBanner()
      }, 3000) // 改为3秒切换一次，更容易观察到效果
    },
    
    // 停止轮播图自动播放
    stopBannerAutoPlay() {
      if (this.bannerTimer) {
        clearInterval(this.bannerTimer)
        this.bannerTimer = null
      }
    },
    
    changeCategory(category) {
      this.currentCategory = category
      // 实际应用中这里会根据分类请求新的数据
    },

    goToComicDetail(id) {
      // 跳转到漫画详情页
      this.$router.push(`/comic/${id}`);
    },
    
    goToCategory() {
      // 跳转到分类页面
      this.$router.push('/category');
    }
  }
}
</script>

<style scoped>
/* 全局样式 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.comic-homepage {
  position: relative;
  overflow: hidden;
}

/* 背景装饰元素 */
.bg-decoration {
  position: absolute;
  border-radius: 50%;
  z-index: -1;
  filter: blur(60px);
  opacity: 0.3;
}

.bg-circle-1 {
  top: -150px;
  left: -100px;
  width: 300px;
  height: 300px;
  background: linear-gradient(135deg, #ff6b6b, #ffa3a3);
  animation: float 15s infinite alternate ease-in-out;
}

.bg-circle-2 {
  bottom: 20%;
  right: -100px;
  width: 400px;
  height: 400px;
  background: linear-gradient(135deg, #4CAF50, #8BC34A);
  animation: float 18s infinite alternate-reverse ease-in-out;
}

.bg-circle-3 {
  top: 40%;
  left: -150px;
  width: 350px;
  height: 350px;
  background: linear-gradient(135deg, #ff9800, #ffc107);
  animation: float 20s infinite alternate ease-in-out;
}

.bg-circle-4 {
  bottom: -100px;
  left: 30%;
  width: 250px;
  height: 250px;
  background: linear-gradient(135deg, #2196F3, #03A9F4);
  animation: float 17s infinite alternate-reverse ease-in-out;
}

@keyframes float {
  0% {
    transform: translate(0, 0) scale(1);
  }
  50% {
    transform: translate(20px, -20px) scale(1.05);
  }
  100% {
    transform: translate(-20px, 20px) scale(0.95);
  }
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 15px;
}

/* 添加页面滚动动画 */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translate3d(0, 30px, 0);
  }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}

section {
  padding: 40px 0;
  animation: fadeInUp 0.6s ease-out both;
}

/* 让各个区域依次显示 */
.hot-recommend {
  animation-delay: 0.1s;
}

.latest-update {
  animation-delay: 0.3s;
}

.completed-works {
  animation-delay: 0.5s;
}

/* 轮播图样式 */
.banner {
  padding: 20px 0;
}

.swiper {
  position: relative;
  height: 400px;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.15);
  transition: transform 0.3s, box-shadow 0.3s;
}

.swiper:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 40px rgba(0, 0, 0, 0.2);
}

.swiper-item {
  position: relative;
  height: 100%;
  display: none;
  transition: opacity 0.5s ease;
}

.swiper-item.active {
  display: block;
  animation: fadeImage 0.5s ease-out;
}

@keyframes fadeImage {
  from {
    opacity: 0.7;
    transform: scale(1.03);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.swiper-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.swiper:hover .swiper-item img {
  transform: scale(1.03);
}

.swiper-item a {
  display: block;
  height: 100%;
}

/* 添加上一张/下一张按钮样式 */
.swiper-btn {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 50px;
  height: 50px;
  background-color: rgba(0, 0, 0, 0.3);
  color: #fff;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s;
  z-index: 10;
  font-size: 20px;
  opacity: 0;
  backdrop-filter: blur(3px);
}

.swiper:hover .swiper-btn {
  opacity: 1;
}

.swiper-btn:hover {
  background-color: rgba(0, 0, 0, 0.6);
  transform: translateY(-50%) scale(1.1);
}

.swiper-btn-prev {
  left: 15px;
}

.swiper-btn-next {
  right: 15px;
}

.swiper-btn i {
  font-style: normal;
}

.swiper-info {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  padding: 20px;
  background: linear-gradient(to top, rgba(0, 0, 0, 0.8), transparent);
  color: #fff;
}

.swiper-info h3 {
  font-size: 24px;
  margin-bottom: 5px;
}

.swiper-dots {
  display: flex;
  justify-content: center;
  margin-top: 15px;
}

.dot {
  width: 12px;
  height: 12px;
  background-color: #ddd;
  border-radius: 50%;
  margin: 0 5px;
  cursor: pointer;
  transition: all 0.3s;
  position: relative;
  overflow: hidden;
}

.dot:hover {
  transform: scale(1.2);
}

.dot.active {
  background-color: #ff6b6b;
  transform: scale(1.2);
}

.dot.active:after {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(255, 107, 107, 0.4);
  border-radius: 50%;
  animation: pulse 1.5s infinite;
}

@keyframes pulse {
  0% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    transform: scale(2.5);
    opacity: 0;
  }
}

/* 区域公共样式 */
.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  position: relative;
  overflow: hidden;
}

.section-header h2 {
  color: #333;
  font-size: 22px;
  position: relative;
  padding-left: 15px;
  transition: transform 0.3s;
}

.section-header:hover h2 {
  transform: translateX(5px);
}

.section-header h2::before {
  content: '';
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 4px;
  height: 20px;
  background-color: #ff6b6b;
  border-radius: 2px;
  transition: height 0.3s;
}

.section-header:hover h2::before {
  height: 30px;
}

.more {
  color: #999;
  text-decoration: none;
  font-size: 14px;
  position: relative;
  transition: all 0.3s;
  padding: 5px 10px;
  border-radius: 15px;
}

.more:hover {
  color: #ff6b6b;
  background-color: rgba(255, 107, 107, 0.1);
}

.more::after {
  content: ">";
  margin-left: 3px;
  transition: transform 0.3s;
  display: inline-block;
}

.more:hover::after {
  transform: translateX(3px);
}

/* 热门推荐样式 */
.comic-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
  gap: 20px;
}

.comic-item {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  transition: all 0.4s cubic-bezier(0.175, 0.885, 0.32, 1.275);
  transform-origin: center bottom;
  position: relative;
}

.comic-item:hover {
  transform: translateY(-10px) scale(1.02);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

.comic-item::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 5px;
  background: linear-gradient(to right, #ff6b6b, #ff9a9e);
  transform: scaleX(0);
  transform-origin: left;
  transition: transform 0.4s ease;
}

.comic-item:hover::after {
  transform: scaleX(1);
}

.comic-cover {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 133%; /* 宽高比约为 3:4 */
  overflow: hidden;
}

.comic-cover img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.comic-item:hover .comic-cover img {
  transform: scale(1.1);
}

.comic-rate {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(255, 107, 107, 0.9);
  color: #fff;
  padding: 3px 10px;
  border-radius: 20px;
  font-size: 14px;
  font-weight: 600;
  transform: translateY(-5px);
  opacity: 0;
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);
  box-shadow: 0 3px 8px rgba(255, 107, 107, 0.3);
}

.comic-item:hover .comic-rate {
  transform: translateY(0);
  opacity: 1;
}

.comic-rate.free {
  background-color: rgba(76, 175, 80, 0.9);
  box-shadow: 0 3px 8px rgba(76, 175, 80, 0.3);
}

.comic-info {
  padding: 15px;
  position: relative;
  z-index: 2;
  background-color: #fff;
  transition: transform 0.3s ease;
}

.comic-item:hover .comic-info {
  transform: translateY(-5px);
}

.comic-title {
  font-size: 18px;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 600;
  color: #333;
  transition: color 0.3s ease;
}

.comic-item:hover .comic-title {
  color: #ff6b6b;
}

.comic-author {
  color: #666;
  font-size: 14px;
  margin-bottom: 10px;
  transition: transform 0.3s ease;
}

.comic-item:hover .comic-author {
  transform: translateX(3px);
}

.comic-desc {
  color: #999;
  font-size: 14px;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  line-height: 1.5;
  transition: color 0.3s ease;
}

.comic-item:hover .comic-desc {
  color: #666;
}

/* 最新更新样式 */
.latest-update {
  background-color: #fff;
  padding: 30px 0;
  position: relative;
}

.latest-update::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(135deg, rgba(255, 107, 107, 0.03) 0%, rgba(255, 107, 107, 0) 100%);
  z-index: 0;
}

.latest-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr); /* 精确指定5列 */
  grid-template-rows: repeat(2, auto); /* 指定2行 */
  gap: 15px;
  position: relative;
  z-index: 1;
}

.latest-card {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  transition: all 0.4s cubic-bezier(0.165, 0.84, 0.44, 1);
  cursor: pointer;
  position: relative;
  isolation: isolate;
}

.latest-card:hover {
  transform: translateY(-10px) scale(1.02);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

.latest-card::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(to right, #4CAF50, #8BC34A);
  transform: scaleX(0);
  transform-origin: right;
  transition: transform 0.4s ease;
}

.latest-card:hover::after {
  transform: scaleX(1);
  transform-origin: left;
}

.latest-card .comic-cover {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 133%; /* 宽高比为3:4 */
  overflow: hidden;
}

.latest-card .comic-cover::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.4) 0%, rgba(0, 0, 0, 0) 30%);
  opacity: 0;
  z-index: 1;
  transition: opacity 0.4s ease;
}

.latest-card:hover .comic-cover::before {
  opacity: 1;
}

.latest-card .comic-cover img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.latest-card:hover .comic-cover img {
  transform: scale(1.1);
}

.update-badge {
  position: absolute;
  top: 10px;
  left: 10px;
  background-color: rgba(255, 107, 107, 0.9);
  color: #fff;
  padding: 4px 12px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 600;
  z-index: 2;
  transform: translateY(-5px);
  opacity: 0;
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);
  box-shadow: 0 3px 8px rgba(255, 107, 107, 0.3);
}

.latest-card:hover .update-badge {
  transform: translateY(0);
  opacity: 1;
}

.update-badge.free {
  background-color: rgba(76, 175, 80, 0.9);
  box-shadow: 0 3px 8px rgba(76, 175, 80, 0.3);
}

.latest-card .comic-title {
  padding: 10px 10px 5px;
  font-size: 15px;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
  transition: color 0.3s ease;
}

.latest-card:hover .comic-title {
  color: #4CAF50;
}

.latest-card .comic-author {
  padding: 0 10px 10px;
  color: #666;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: transform 0.3s ease;
}

.latest-card:hover .comic-author {
  transform: translateX(3px);
}

/* 完结佳作样式 */
.completed-works {
  background-color: #f9f9f9;
  padding: 30px 0;
  position: relative;
  overflow: hidden;
}

.completed-works::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(circle at 10% 10%, rgba(255, 107, 107, 0.05), transparent 50%);
  z-index: 0;
}

.completed-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr); /* 精确指定5列 */
  grid-template-rows: repeat(2, auto); /* 指定2行 */
  gap: 15px;
  position: relative;
  z-index: 1;
}

.completed-card {
  display: flex;
  flex-direction: column;
  background-color: #fff;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  transition: all 0.4s cubic-bezier(0.19, 1, 0.22, 1);
  cursor: pointer;
  position: relative;
  isolation: isolate;
}

.completed-card:hover {
  transform: translateY(-10px) scale(1.02);
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
}

.completed-card::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(to right, #ffc107, #ff9800);
  transform: scaleX(0);
  transform-origin: center;
  transition: transform 0.4s ease;
}

.completed-card:hover::after {
  transform: scaleX(1);
}

.completed-card .comic-cover {
  position: relative;
  width: 100%;
  height: 0;
  padding-bottom: 133%; /* 宽高比为3:4 */
  overflow: hidden;
}

.completed-card .comic-cover::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.3) 0%, rgba(0, 0, 0, 0) 40%);
  opacity: 0;
  z-index: 1;
  transition: opacity 0.4s ease;
}

.completed-card:hover .comic-cover::before {
  opacity: 1;
}

.completed-card .comic-cover img {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.completed-card:hover .comic-cover img {
  transform: scale(1.1) rotate(1deg);
}

.rating-badge {
  position: absolute;
  top: 10px;
  right: 10px;
  background-color: rgba(255, 107, 107, 0.9);
  color: #fff;
  padding: 4px 12px;
  border-radius: 20px;
  font-weight: 600;
  font-size: 12px;
  z-index: 2;
  transform: translateY(-5px);
  opacity: 0;
  transition: all 0.3s ease;
  backdrop-filter: blur(5px);
  box-shadow: 0 3px 8px rgba(255, 107, 107, 0.3);
}

.completed-card:hover .rating-badge {
  transform: translateY(0);
  opacity: 1;
}

.rating-badge.free {
  background-color: rgba(76, 175, 80, 0.9);
  box-shadow: 0 3px 8px rgba(76, 175, 80, 0.3);
}

.completed-card .comic-title {
  padding: 10px 10px 5px;
  font-size: 15px;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 500;
  transition: color 0.3s ease;
}

.completed-card:hover .comic-title {
  color: #ff9800;
}

.completed-card .comic-author {
  padding: 0 10px 10px;
  color: #666;
  font-size: 13px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  transition: transform 0.3s ease;
}

.completed-card:hover .comic-author {
  transform: translateX(3px);
}

/* 媒体查询 - 响应式设计 */
@media screen and (max-width: 1200px) {
  .latest-grid {
    grid-template-columns: repeat(4, 1fr); /* 1200px以下显示4列 */
  }
  
  .completed-grid {
    grid-template-columns: repeat(4, 1fr); /* 1200px以下显示4列 */
  }
}

@media screen and (max-width: 992px) {
  .comic-list {
    grid-template-columns: repeat(auto-fill, minmax(230px, 1fr));
  }
  
  .latest-grid {
    grid-template-columns: repeat(3, 1fr); /* 992px以下显示3列 */
  }
  
  .completed-grid {
    grid-template-columns: repeat(3, 1fr); /* 992px以下显示3列 */
  }
}

@media screen and (max-width: 768px) {
  .latest-grid {
    grid-template-columns: repeat(2, 1fr); /* 768px以下显示2列 */
  }
  
  .completed-grid {
    grid-template-columns: repeat(2, 1fr); /* 768px以下显示2列 */
  }
}

@media screen and (max-width: 576px) {
  .latest-grid {
    grid-template-columns: repeat(2, 1fr); /* 576px以下仍然显示2列 */
    gap: 10px;
  }
  
  .completed-grid {
    grid-template-columns: repeat(2, 1fr); /* 576px以下仍然显示2列 */
    gap: 10px;
  }
}

/* 粒子特效样式 */
.particles-container {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  overflow: hidden;
  z-index: -1;
  pointer-events: none;
}

.particle {
  position: absolute;
  border-radius: 50%;
  opacity: 0.5;
  animation-iteration-count: infinite;
  animation-timing-function: linear;
}

.particle-1, .particle-2, .particle-3, .particle-4, .particle-5, .particle-6 {
  background-color: rgba(255, 107, 107, 0.6);
  filter: blur(1px);
  width: 8px;
  height: 8px;
}

.particle-7, .particle-8, .particle-9 {
  background-color: rgba(76, 175, 80, 0.6);
  filter: blur(1px);
  width: 6px;
  height: 6px;
}

.particle-10, .particle-11, .particle-12 {
  background-color: rgba(33, 150, 243, 0.6);
  filter: blur(1px);
  width: 4px;
  height: 4px;
}

.particle-star-1, .particle-star-2, .particle-star-3, .particle-star-4, .particle-star-5 {
  background-color: transparent;
  width: 15px;
  height: 15px;
  filter: blur(0);
  opacity: 0.8;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='%23ffc107' stroke='%23ffc107' stroke-width='0.5' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolygon points='12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2'%3E%3C/polygon%3E%3C/svg%3E");
  background-size: contain;
  background-repeat: no-repeat;
  animation: twinkle 5s infinite alternate;
}

.particle-1 {
  top: 10%;
  left: 10%;
  animation: moveParticle1 30s infinite;
}

.particle-2 {
  top: 30%;
  left: 15%;
  animation: moveParticle2 25s infinite;
}

.particle-3 {
  top: 60%;
  left: 5%;
  animation: moveParticle3 35s infinite;
}

.particle-4 {
  top: 15%;
  right: 10%;
  animation: moveParticle4 20s infinite;
}

.particle-5 {
  top: 45%;
  right: 5%;
  animation: moveParticle5 40s infinite;
}

.particle-6 {
  top: 75%;
  right: 15%;
  animation: moveParticle6 30s infinite;
}

.particle-7 {
  top: 25%;
  left: 30%;
  animation: moveParticle7 25s infinite;
}

.particle-8 {
  top: 65%;
  left: 35%;
  animation: moveParticle8 35s infinite;
}

.particle-9 {
  top: 80%;
  left: 65%;
  animation: moveParticle9 30s infinite;
}

.particle-10 {
  top: 40%;
  left: 75%;
  animation: moveParticle10 20s infinite;
}

.particle-11 {
  top: 85%;
  left: 25%;
  animation: moveParticle11 40s infinite;
}

.particle-12 {
  top: 5%;
  left: 50%;
  animation: moveParticle12 30s infinite;
}

.particle-star-1 {
  top: 15%;
  left: 25%;
  animation: moveParticleStar1 50s infinite, twinkle 3s infinite alternate;
}

.particle-star-2 {
  top: 35%;
  right: 25%;
  animation: moveParticleStar2 45s infinite, twinkle 4s infinite alternate;
}

.particle-star-3 {
  top: 65%;
  right: 40%;
  animation: moveParticleStar3 55s infinite, twinkle 5s infinite alternate;
}

.particle-star-4 {
  top: 80%;
  left: 75%;
  animation: moveParticleStar4 40s infinite, twinkle 6s infinite alternate;
}

.particle-star-5 {
  top: 20%;
  left: 60%;
  animation: moveParticleStar5 60s infinite, twinkle 7s infinite alternate;
}

@keyframes moveParticle1 {
  0%, 100% { transform: translate(0, 0); }
  25% { transform: translate(100px, 50px); }
  50% { transform: translate(50px, 100px); }
  75% { transform: translate(-50px, 50px); }
}

@keyframes moveParticle2 {
  0%, 100% { transform: translate(0, 0); }
  25% { transform: translate(-80px, 60px); }
  50% { transform: translate(-30px, -60px); }
  75% { transform: translate(80px, 10px); }
}

@keyframes moveParticle3 {
  0%, 100% { transform: translate(0, 0); }
  25% { transform: translate(70px, -40px); }
  50% { transform: translate(140px, 30px); }
  75% { transform: translate(50px, 80px); }
}

@keyframes moveParticle4 {
  0%, 100% { transform: translate(0, 0); }
  25% { transform: translate(-60px, 30px); }
  50% { transform: translate(-120px, -20px); }
  75% { transform: translate(-50px, -70px); }
}

@keyframes moveParticle5 {
  0%, 100% { transform: translate(0, 0); }
  25% { transform: translate(-40px, -80px); }
  50% { transform: translate(30px, -120px); }
  75% { transform: translate(70px, -50px); }
}

@keyframes moveParticle6 {
  0%, 100% { transform: translate(0, 0); }
  25% { transform: translate(-100px, -30px); }
  50% { transform: translate(-50px, -80px); }
  75% { transform: translate(20px, -40px); }
}

@keyframes moveParticle7 {
  0%, 100% { transform: translate(0, 0); }
  25% { transform: translate(80px, 20px); }
  50% { transform: translate(40px, 80px); }
  75% { transform: translate(-30px, 40px); }
}

@keyframes moveParticle8 {
  0%, 100% { transform: translate(0, 0); }
  25% { transform: translate(-70px, -40px); }
  50% { transform: translate(-30px, -90px); }
  75% { transform: translate(40px, -60px); }
}

@keyframes moveParticle9 {
  0%, 100% { transform: translate(0, 0); }
  25% { transform: translate(60px, -60px); }
  50% { transform: translate(120px, -20px); }
  75% { transform: translate(80px, 30px); }
}

@keyframes moveParticle10 {
  0%, 100% { transform: translate(0, 0); }
  25% { transform: translate(-40px, 60px); }
  50% { transform: translate(-90px, 10px); }
  75% { transform: translate(-30px, -40px); }
}

@keyframes moveParticle11 {
  0%, 100% { transform: translate(0, 0); }
  25% { transform: translate(50px, -50px); }
  50% { transform: translate(90px, 20px); }
  75% { transform: translate(30px, 70px); }
}

@keyframes moveParticle12 {
  0%, 100% { transform: translate(0, 0); }
  25% { transform: translate(-60px, 50px); }
  50% { transform: translate(-100px, 100px); }
  75% { transform: translate(-30px, 60px); }
}

@keyframes moveParticleStar1 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  25% { transform: translate(120px, 80px) rotate(90deg); }
  50% { transform: translate(60px, 140px) rotate(180deg); }
  75% { transform: translate(-50px, 70px) rotate(270deg); }
}

@keyframes moveParticleStar2 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  25% { transform: translate(-100px, 50px) rotate(90deg); }
  50% { transform: translate(-150px, -50px) rotate(180deg); }
  75% { transform: translate(-70px, -120px) rotate(270deg); }
}

@keyframes moveParticleStar3 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  25% { transform: translate(80px, -70px) rotate(90deg); }
  50% { transform: translate(150px, -20px) rotate(180deg); }
  75% { transform: translate(100px, 80px) rotate(270deg); }
}

@keyframes moveParticleStar4 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  25% { transform: translate(-60px, -60px) rotate(90deg); }
  50% { transform: translate(-20px, -130px) rotate(180deg); }
  75% { transform: translate(70px, -80px) rotate(270deg); }
}

@keyframes moveParticleStar5 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  25% { transform: translate(130px, 40px) rotate(90deg); }
  50% { transform: translate(80px, 120px) rotate(180deg); }
  75% { transform: translate(-20px, 90px) rotate(270deg); }
}

@keyframes twinkle {
  0%, 100% { opacity: 0.8; transform: scale(1); }
  50% { opacity: 0.3; transform: scale(0.8); }
}

/* 浮动图标样式 */
.floating-icons {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: -1;
}

.floating-icon {
  position: absolute;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation-duration: 6s;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  opacity: 0.15;
}

.icon-book {
  top: 25%;
  left: 8%;
  color: #ff6b6b;
  animation-name: floatIcon1;
}

.icon-star {
  top: 15%;
  right: 10%;
  color: #ffc107;
  animation-name: floatIcon2;
}

.icon-heart {
  bottom: 20%;
  right: 15%;
  color: #ff4081;
  animation-name: floatIcon3;
}

@keyframes floatIcon1 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  25% { transform: translate(15px, -15px) rotate(5deg); }
  50% { transform: translate(0, -25px) rotate(0deg); }
  75% { transform: translate(-15px, -15px) rotate(-5deg); }
}

@keyframes floatIcon2 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  25% { transform: translate(-15px, 10px) rotate(-5deg); }
  50% { transform: translate(-25px, 0) rotate(-10deg); }
  75% { transform: translate(-15px, -10px) rotate(-5deg); }
}

@keyframes floatIcon3 {
  0%, 100% { transform: translate(0, 0) rotate(0deg); }
  25% { transform: translate(-10px, -15px) rotate(5deg); }
  50% { transform: translate(0, -20px) rotate(10deg); }
  75% { transform: translate(10px, -15px) rotate(5deg); }
}

/* 鼠标追踪光效 */
.mouse-glow {
  position: fixed;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 107, 107, 0.1) 0%, rgba(255, 107, 107, 0) 70%);
  pointer-events: none;
  transform: translate(-50%, -50%);
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 1;
  mix-blend-mode: screen;
}

.mouse-glow.active {
  opacity: 1;
  animation: pulseGlow 2s infinite;
}

@keyframes pulseGlow {
  0%, 100% { transform: translate(-50%, -50%) scale(1); }
  50% { transform: translate(-50%, -50%) scale(1.2); }
}

/* 呼吸灯效果 */
.breathing-light {
  position: fixed;
  top: 20px;
  right: 20px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: #4CAF50;
  box-shadow: 0 0 10px #4CAF50, 0 0 20px #4CAF50;
  z-index: 100;
  animation: breathing 3s ease-in-out infinite;
}

@keyframes breathing {
  0%, 100% {
    opacity: 1;
    box-shadow: 0 0 10px #4CAF50, 0 0 20px #4CAF50;
    transform: scale(1);
  }
  50% {
    opacity: 0.5;
    box-shadow: 0 0 5px #4CAF50, 0 0 10px #4CAF50;
    transform: scale(0.9);
  }
}
</style>

<style scoped>
.comic-homepage {
  background:
    linear-gradient(180deg, rgba(255,255,255,0.78), rgba(255,255,255,0.3)),
    radial-gradient(circle at 8% 0%, rgba(34, 211, 215, 0.16), transparent 30%),
    radial-gradient(circle at 92% 12%, rgba(23, 34, 63, 0.12), transparent 32%);
  min-height: 100vh;
}

.comic-homepage .container {
  max-width: 1500px;
  padding: 0 30px;
}

.comic-homepage section {
  padding: 34px 0;
  transform: none !important;
  filter: none !important;
}

.banner {
  padding-top: 26px;
}

.swiper {
  height: clamp(220px, 24vw, 360px);
  border-radius: 30px;
  box-shadow: 0 28px 72px rgba(31, 48, 92, 0.18);
  border: 1px solid rgba(255, 255, 255, 0.72);
}

.swiper::after {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: linear-gradient(90deg, rgba(12, 22, 58, 0.34), transparent 48%, rgba(34, 211, 215, 0.16));
  z-index: 2;
}

.swiper-btn {
  width: 46px;
  height: 46px;
  background: rgba(255, 255, 255, 0.88);
  color: #315cf6;
  box-shadow: 0 14px 30px rgba(23, 42, 104, 0.22);
}

.swiper-btn:hover {
  background: #fff;
  color: #7c3aed;
}

.dot {
  width: 34px;
  height: 7px;
  border-radius: 999px;
  background: #d7e2ff;
}

.dot.active {
  background: linear-gradient(135deg, #22d3d7, #17223f);
}

.section-header {
  background: rgba(255, 255, 255, 0.9);
  border: 1px solid rgba(23, 34, 63, 0.08);
  box-shadow: 0 18px 42px rgba(31, 48, 92, 0.07);
  border-radius: 24px;
  padding: 18px 24px;
  backdrop-filter: blur(16px);
}

.section-header h2 {
  color: #1f2a4d;
  font-size: 26px;
  padding-left: 0;
  letter-spacing: 0;
}

.section-header h2::before {
  display: none;
}

.section-header h2::after {
  content: "";
  display: block;
  width: 54px;
  height: 5px;
  margin-top: 8px;
  border-radius: 999px;
  background: linear-gradient(135deg, #22d3d7, #17223f);
}

.more {
  color: #0f9fa7;
  background: #e9fbfb;
  font-weight: 800;
  border-radius: 999px;
  padding: 10px 16px;
}

.comic-list {
  grid-template-columns: 1.25fr repeat(3, minmax(0, 1fr));
  gap: 24px;
  align-items: stretch;
}

.latest-grid,
.completed-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 22px;
}

.comic-item,
.latest-card,
.completed-card {
  border-radius: 22px;
  border: 1px solid rgba(23, 34, 63, 0.08);
  box-shadow: 0 18px 44px rgba(31, 48, 92, 0.1);
  background: rgba(255, 255, 255, 0.94);
  overflow: hidden;
}

.comic-list .comic-item:first-child {
  grid-row: span 2;
}

.comic-list .comic-item:first-child .comic-cover {
  height: 520px;
}

.comic-list .comic-item:first-child .comic-title {
  font-size: 24px;
}

.comic-list .comic-item:first-child .comic-desc {
  display: block;
  height: auto;
  max-height: 96px;
}

.comic-item:hover,
.latest-card:hover,
.completed-card:hover {
  box-shadow: 0 26px 58px rgba(31, 48, 92, 0.16);
}

.comic-cover {
  background: linear-gradient(135deg, #e8f7ff, #f0ecff);
}

.comic-info {
  padding: 18px;
}

.comic-title {
  color: #1f2a4d;
  font-weight: 800;
}

.comic-author {
  color: #53617f;
}

.comic-desc {
  color: #72809e;
}

.comic-rate,
.update-badge,
.rating-badge {
  background: linear-gradient(135deg, #ff6a75, #17223f);
  box-shadow: 0 10px 24px rgba(23, 34, 63, 0.22);
}

.comic-rate.free,
.update-badge.free,
.rating-badge.free {
  background: linear-gradient(135deg, #22c55e, #22d3d7);
}

.latest-update,
.completed-works {
  background: transparent;
}

@media (max-width: 1100px) {
  .comic-list,
  .latest-grid,
  .completed-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .comic-list .comic-item:first-child {
    grid-row: auto;
  }

  .comic-list .comic-item:first-child .comic-cover {
    height: 320px;
  }
}

@media (max-width: 720px) {
  .comic-homepage .container {
    padding: 0 16px;
  }

  .comic-list,
  .latest-grid,
  .completed-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 14px;
  }

  .swiper {
    height: 210px;
    border-radius: 22px;
  }

  .section-header {
    padding: 14px 16px;
  }

  .section-header h2 {
    font-size: 21px;
  }
}
</style>

<style scoped>
/* 结构重构：漫画馆首页 */
.cinema-dashboard {
  padding: 36px 0 24px;
}

.dashboard-grid {
  display: grid;
  grid-template-columns: minmax(0, 1.7fr) 390px;
  gap: 22px;
  align-items: stretch;
}

.spotlight-panel {
  min-height: 560px;
  position: relative;
  display: grid;
  grid-template-columns: minmax(280px, 0.86fr) minmax(0, 1fr);
  overflow: hidden;
  cursor: pointer;
  border-radius: 10px;
  background: linear-gradient(135deg, rgba(22, 26, 43, 0.98), rgba(8, 10, 18, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 32px 86px rgba(0, 0, 0, 0.46);
}

.spotlight-panel::after {
  content: "";
  position: absolute;
  inset: 0;
  pointer-events: none;
  background:
    linear-gradient(90deg, transparent 0 42%, rgba(5, 7, 14, 0.42) 60%, rgba(5, 7, 14, 0.9)),
    radial-gradient(circle at 82% 18%, rgba(255, 204, 102, 0.18), transparent 30%);
}

.spotlight-cover {
  min-height: 560px;
  background: #070912;
}

.spotlight-cover img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  filter: saturate(1.08) contrast(1.08);
}

.spotlight-copy {
  position: relative;
  z-index: 2;
  align-self: end;
  padding: 42px;
}

.eyebrow {
  margin: 0 0 12px;
  color: #ffcc66;
  font-size: 13px;
  font-weight: 900;
}

.spotlight-copy h1 {
  margin: 0;
  color: #fff;
  font-size: clamp(42px, 5vw, 82px);
  line-height: 0.96;
}

.spotlight-desc {
  max-width: 620px;
  margin: 20px 0 0;
  color: #b7c1dc;
  font-size: 16px;
  line-height: 1.8;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.spotlight-meta {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  margin-top: 20px;
}

.spotlight-meta span {
  padding: 8px 12px;
  border-radius: 8px;
  color: #dfe8ff;
  background: rgba(255, 255, 255, 0.08);
}

.read-now {
  margin-top: 24px;
  border: 0;
  border-radius: 8px;
  padding: 14px 28px;
  color: #07101d;
  font-weight: 900;
  cursor: pointer;
  background: linear-gradient(135deg, #ffcc66, #23d3ee);
}

.ranking-panel,
.editor-picks {
  padding: 18px;
  border-radius: 10px;
  background: linear-gradient(180deg, rgba(20, 24, 39, 0.96), rgba(10, 13, 24, 0.98));
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 28px 70px rgba(0, 0, 0, 0.34);
}

.panel-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 14px;
}

.panel-title span,
.editor-picks h2 {
  color: #f8fbff;
  font-size: 24px;
  font-weight: 900;
}

.panel-title button {
  border: 0;
  border-radius: 8px;
  padding: 8px 12px;
  color: #07101d;
  font-weight: 900;
  background: linear-gradient(135deg, #ffcc66, #23d3ee);
}

.rank-row {
  display: grid;
  grid-template-columns: 42px 58px minmax(0, 1fr);
  gap: 12px;
  align-items: center;
  padding: 12px 0;
  cursor: pointer;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
}

.rank-row strong {
  color: #ffcc66;
  font-size: 18px;
}

.rank-row img {
  width: 58px;
  height: 76px;
  object-fit: cover;
  border-radius: 8px;
}

.rank-row h3,
.pick-card h3 {
  margin: 0 0 6px;
  color: #f8fbff;
  font-size: 15px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.rank-row p,
.pick-card p {
  margin: 0;
  color: #9faaca;
  font-size: 12px;
}

.quick-lanes {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 14px;
  margin-top: 18px;
}

.quick-lanes button {
  min-height: 74px;
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 10px;
  color: #f8fbff;
  font-size: 16px;
  font-weight: 900;
  cursor: pointer;
  background:
    radial-gradient(circle at 80% 20%, rgba(35, 211, 238, 0.18), transparent 34%),
    rgba(255, 255, 255, 0.06);
}

.shelf-layout {
  display: grid;
  grid-template-columns: minmax(0, 1fr) 360px;
  gap: 22px;
  align-items: start;
}

.shelf-grid {
  grid-template-columns: repeat(4, minmax(0, 1fr)) !important;
}

.editor-picks h2 {
  margin: 0 0 16px;
}

.pick-card {
  display: grid;
  grid-template-columns: 72px minmax(0, 1fr);
  gap: 12px;
  padding: 12px 0;
  cursor: pointer;
  border-bottom: 1px solid rgba(255, 255, 255, 0.07);
}

.pick-card img {
  width: 72px;
  height: 96px;
  object-fit: cover;
  border-radius: 8px;
}

.pick-card p {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.6;
}

@media (max-width: 1180px) {
  .dashboard-grid,
  .shelf-layout {
    grid-template-columns: 1fr;
  }

  .spotlight-panel {
    grid-template-columns: 0.8fr 1fr;
  }

  .shelf-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }
}

@media (max-width: 720px) {
  .spotlight-panel {
    min-height: 0;
    grid-template-columns: 1fr;
  }

  .spotlight-cover {
    min-height: 360px;
  }

  .spotlight-copy {
    padding: 24px;
  }

  .quick-lanes {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .shelf-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}

/* 深色漫画馆主题覆盖 */
.comic-homepage {
  color: #eef3ff;
  background:
    radial-gradient(circle at 12% 0%, rgba(255, 204, 102, 0.14), transparent 28%),
    radial-gradient(circle at 86% 12%, rgba(35, 211, 238, 0.1), transparent 28%),
    linear-gradient(180deg, rgba(7, 9, 18, 0.3), rgba(7, 9, 18, 0.78)) !important;
}

.comic-homepage .container {
  max-width: 1540px;
}

.comic-homepage section {
  padding: 42px 0;
}

.swiper {
  height: clamp(380px, 42vw, 640px) !important;
  border-radius: 0 !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  box-shadow: 0 38px 95px rgba(0, 0, 0, 0.46) !important;
}

.swiper::before {
  content: "DAOHAN COMICS";
  position: absolute;
  left: 34px;
  bottom: 34px;
  z-index: 5;
  color: rgba(255, 255, 255, 0.9);
  font-size: clamp(32px, 6vw, 92px);
  font-weight: 900;
  letter-spacing: 0;
  line-height: 0.9;
  max-width: 620px;
  pointer-events: none;
}

.swiper::after {
  background:
    linear-gradient(90deg, rgba(5, 7, 14, 0.86), rgba(5, 7, 14, 0.16) 54%, rgba(5, 7, 14, 0.62)),
    linear-gradient(0deg, rgba(5, 7, 14, 0.82), transparent 52%) !important;
}

.swiper-item img {
  filter: saturate(1.12) contrast(1.08);
}

.swiper-dots {
  margin-top: 18px;
}

.dot {
  background: rgba(255, 255, 255, 0.16) !important;
}

.dot.active {
  background: linear-gradient(135deg, #ffcc66, #23d3ee) !important;
}

.section-header {
  margin-bottom: 22px;
  padding: 0 !important;
  background: transparent !important;
  border: 0 !important;
  box-shadow: none !important;
}

.section-header h2 {
  color: #f8fbff !important;
  font-size: clamp(28px, 3.4vw, 48px) !important;
  font-weight: 900;
}

.section-header h2::after {
  width: 82px;
  height: 5px;
  background: linear-gradient(135deg, #ffcc66, #23d3ee) !important;
}

.more {
  color: #07101d !important;
  background: linear-gradient(135deg, #ffcc66, #23d3ee) !important;
  border-radius: 8px !important;
  padding: 11px 16px !important;
}

.comic-list {
  grid-template-columns: minmax(300px, 1.3fr) repeat(3, minmax(180px, 1fr)) !important;
  gap: 20px !important;
}

.latest-grid,
.completed-grid {
  grid-template-columns: repeat(5, minmax(0, 1fr)) !important;
  gap: 18px !important;
}

.comic-item,
.latest-card,
.completed-card {
  background: linear-gradient(180deg, rgba(22, 26, 43, 0.98), rgba(10, 13, 24, 0.98)) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
  border-radius: 10px !important;
  box-shadow: 0 24px 54px rgba(0, 0, 0, 0.34) !important;
  overflow: hidden;
}

.comic-item:hover,
.latest-card:hover,
.completed-card:hover {
  border-color: rgba(255, 204, 102, 0.38) !important;
  box-shadow: 0 32px 70px rgba(0, 0, 0, 0.48) !important;
}

.comic-list .comic-item:first-child {
  grid-row: span 2;
}

.comic-list .comic-item:first-child .comic-cover {
  height: 560px !important;
}

.comic-list .comic-item:first-child .comic-title {
  font-size: 28px !important;
}

.comic-cover {
  background: #070912 !important;
}

.comic-cover img {
  filter: saturate(1.08) contrast(1.06);
}

.comic-info {
  background: linear-gradient(180deg, rgba(14, 18, 31, 0.72), rgba(8, 11, 20, 0.98));
}

.comic-title {
  color: #f8fbff !important;
}

.comic-author,
.comic-desc {
  color: #9faaca !important;
}

.comic-rate,
.update-badge,
.rating-badge {
  color: #07101d !important;
  background: linear-gradient(135deg, #ffcc66, #23d3ee) !important;
}

.comic-rate.free,
.update-badge.free,
.rating-badge.free {
  background: linear-gradient(135deg, #23d3ee, #a7f3d0) !important;
}

.completed-works::before {
  display: none;
}

@media (max-width: 1180px) {
  .comic-list,
  .latest-grid,
  .completed-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }

  .comic-list .comic-item:first-child {
    grid-row: auto;
  }

  .comic-list .comic-item:first-child .comic-cover {
    height: 320px !important;
  }
}

@media (max-width: 720px) {
  .comic-homepage .container {
    padding: 0 16px;
  }

  .swiper {
    height: 300px !important;
  }

  .swiper::before {
    left: 18px;
    bottom: 24px;
    font-size: 38px;
  }

  .comic-list,
  .latest-grid,
  .completed-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}
</style>
